<template>
    <transition name="el-fade-in-linear">
    <div v-show="transitionshow"> 
      
	    <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
            <el-form-item>
                <el-input placeholder="请输入等级名称" v-model="query.key" @keyup.enter.native="getlists" @change="isselect=true" clearable></el-input>
            </el-form-item>
            <el-form-item>
            	<el-button type="primary" icon="el-icon-search" @click="getlists">查询</el-button>
            	<el-button type="danger" icon="el-icon-circle-plus-outline" @click="addlevel">新增</el-button>
            </el-form-item>
        </el-form>
        
        <div class="backborder2" style="margin-top:10px">
        	<el-table :data="lists" style="width: 100%" v-loading="listLoading">	    		
		        <el-table-column label="等级名称" prop="name"></el-table-column>		      
		        <el-table-column label="操作" align="center" width="150">
		        	<template slot-scope="scope">
						<el-button type="warning" size="small" icon="el-icon-edit" @click="editCurrent(scope.row)" circle></el-button>
						<el-button type="danger" size="small" icon="el-icon-delete" @click="del(scope.row)" circle></el-button>
					</template>
		        </el-table-column>		      
	        </el-table>
	        <div class="block">
	            <!--分页begin-->
	            <el-pagination
		            @size-change="queryPageSizeChange"
		            @current-change="queryPageCurrentChange"
		            :current-page="query.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="query.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="total_rows">
	            </el-pagination>
	            <!--分页end-->
	        </div> 
        </div>
        
        <!---------------新增客户等级------------------->
        <el-dialog title="新增等级" :visible.sync="addlevelDialog" top="20vh" width="20%">
        	<el-form :inline="true" class="demo-form-inline" size="small">
	            <el-form-item>
	                <el-input placeholder="请输入等级名称" v-model="create.name"></el-input>
	            </el-form-item>
        	</el-form>
        	<div slot="footer" class="dialog-footer">
            	<el-button size="small" @click="addlevelDialog=false">取 消</el-button>
            	<el-button size="small" type="primary" :loading="saveLoading" @click="savelevel">保 存</el-button>
            </div>
        </el-dialog>
        
        <!---------------新增客户等级------------------->
        <el-dialog title="编辑等级" :visible.sync="updatelevelDialog" top="20vh" width="20%">
        	<el-form :inline="true" class="demo-form-inline" size="small">
	            <el-form-item>
	                <el-input placeholder="请输入等级名称" v-model="update.name"></el-input>
	            </el-form-item>
        	</el-form>
        	<div slot="footer" class="dialog-footer">
            	<el-button size="small" @click="updatelevelDialog=false">取 消</el-button>
            	<el-button size="small" type="primary" :loading="updateLoading" @click="editlevel">保 存</el-button>
            </div>
        </el-dialog>
  
    </div>
    </transition>
</template>

<script>

export default {
    data () {
	    return {
	        actionauth:'', //操作权限
	        transitionshow:true,
	        url:this.GLOBAL.domain+"Customer/index",
	        query: {
	        	act:'getLevel',
	        	token:this.$cookies.get('token'),
	        	key:'',
	        	p:1,
	        	rollpage:10
	        },
	        isselect:false,
	        total_rows:0,
	        listLoading:false,
	        lists:[],
	        addlevelDialog:false,
	        create: {
	        	act:'addlevel',
	        	token:this.$cookies.get('token'),
	        	name:'',
	        },
	        saveLoading:false,
	        update: {
	        	act:'editlevel',
	        	token:this.$cookies.get('token'),
	        	id:'',
	        	name:'',
	        },
	        updateLoading:false,
	        updatelevelDialog:false,
	    }
    },
    
    mounted(){
        this.getactionauth();
      	this.getlists();
    },
    
    methods:{  
  
	  	/** 获取操作权限 **/
	  	getactionauth() {
	    	var data =this.$cookies.get('actionauth');
	    	data=JSON.parse(data);
	        this.actionauth=data;
	    },
    	
    	getlists() {
    		if(this.isselect==true) {
    		   this.query.p=1;
    		   this.query.rollpage=10;
    	    }      
    	    this.listLoading=true;
    	    var resource = this.$resource(this.url);
            resource.query(this.query).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.listLoading=false;
                }else{
                    this.lists = JSON.parse(Base64.decode(res.data.Data));
                    this.total_rows=parseInt(res.data.count);
                    this.listLoading=false;
                    if(this.isselect==true) this.isselect=false;
                }
            }).catch((res) => {
                this.listLoading=false;
            });
    	},
    	
    	queryPageSizeChange(val) {
  	   	   this.query.rollpage = val;
           this.getlists();
  	    },
  	    queryPageCurrentChange(val) {
  	   	   this.query.p = val;
           this.getlists();
  	    },
  	    
  	    /** 新增等级 **/
    	addlevel() {
    		this.addlevelDialog=true;
    		this.create.name='';
    	},
    	
    	/** 保存客户等级 **/
    	savelevel() {
    		this.saveLoading=true;
    		var resource = this.$resource(this.url);
            resource.query(this.create).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.saveLoading=false;
                }else{
                    this.$message.success("添加客户等级成功！");
                    this.saveLoading=false;
                    this.addlevelDialog=false;
                    this.getlists();
                }
            }).catch((res) => {
                this.saveLoading=false;
            });
    	},
    	
    	/** 获取等级信息 **/
    	editCurrent(item) {
    		this.update.id=item.id;
    		this.update.name=item.name;
    		this.updatelevelDialog=true;
    	},
    	
    	/** 保存编辑的等级信息 **/
    	editlevel() {
    		this.updateLoading=true;	        
	        var resource = this.$resource(this.url);
            resource.query(this.update).then((res) => {
                if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
                    this.updateLoading=false;
                }else{
                    this.$message.success("编辑客户等级成功！");
                    this.updateLoading=false;
                    this.updatelevelDialog=false;
                    this.getlists();
                }
            }).catch((res) => {
                this.updateLoading=false;
            });
    	},
    	
    	/** 删除客户等级信息 **/
    	del(item) {
    		this.$confirm('您是否要删除该会员等级, 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'dellevel',id:item.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                  }else{
                      this.$message.success('成功删除了' + item.name + '!');
                      this.getlists();
                  }
              }).catch((res) => {
                  this.$message.error(this.GLOBAL.errortext);
              });
          }).catch(() => {
              
          });
    	},
    	
    }
}
</script>
<style type="text/css">
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
</style>


// WEBPACK FOOTER //
// src/components/base/Customerlevel.vue